import React, { Suspense, lazy } from "react";
import { geoCluster, getRelatedMoneyPages, getRelatedIndustryPages, getRelatedInsightPages } from "@/data/contentClusters";

const MoneyPageTemplate = lazy(() => import("@/components/templates/MoneyPageTemplate").then((m) => ({ default: m.MoneyPageTemplate })));

const pageData = geoCluster.moneyPages.find(p => p.slug === "cloud-seo")!;
const relatedMoney = getRelatedMoneyPages("geo").filter(p => p.slug !== pageData.slug);
const relatedIndustry = getRelatedIndustryPages("geo");
const relatedInsights = getRelatedInsightPages("geo");

export default function CloudSEOPage() {
  return (
    <Suspense fallback={<div className="container-wide py-24">Loading…</div>}>
      <MoneyPageTemplate
        page={pageData}
        pillarTitle={geoCluster.pillar.subtitle}
        relatedMoneyPages={relatedMoney.map(p => ({ title: p.title, slug: p.slug }))}
        relatedIndustryPages={relatedIndustry.map(p => ({ title: p.title, slug: p.slug }))}
        relatedInsightPages={relatedInsights.map(p => ({ title: p.title, slug: p.slug }))}
      />
    </Suspense>
  );
}
